import { createContext } from 'react';

/**
 * Set by `RichTextElement` when a Rich Text holding inline fields / Goal blocks
 * is being filled (`fill` prop): the nodes' views read it and draw fill controls
 * instead of the builder's chips. `null` everywhere else (template builder).
 *
 * `{ disabled, hideStaffOnly, showErrors, imageUrls, errorFor(id), markTouched(id) }`
 *
 * A file of its own so the node extensions and the fill components can import
 * it without an import cycle at load time.
 */
export const InlineFillContext = createContext(null);
